import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const ThumbnailImage = styled.img`
    max-width: 100%;
    height: auto;
`;

const ThumbnailBody = ({ src, className, title }) => (
    <div className={className}>
        <ThumbnailImage src={src} title={title} />
    </div>
);

export const Thumbnail = styled(ThumbnailBody)`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

Thumbnail.propTypes = {
    src: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string
};
